import React from "react";
import Icon from "../Icon";

export default props => (
  <Icon viewBox="0 0 32 32" {...props}>
    <path
      d="M20 20l-4-4V9m0 19c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12z"
      fill="none"
    />
  </Icon>
);
